// Create types
export const FILETYPE_CREATE_ERROR = 'FILETYPE_CREATE_ERROR';
export const FILETYPE_CREATE_LOADING = 'FILETYPE_CREATE_LOADING';
export const FILETYPE_CREATE_SUCCESS = 'FILETYPE_CREATE_SUCCESS';
export const FILETYPE_CREATE_VIOLATIONS = 'FILETYPE_CREATE_VIOLATIONS';
export const FILETYPE_CREATE_RESET = 'FILETYPE_CREATE_RESET';

// Show types
export const FILETYPE_SHOW_ERROR = 'FILETYPE_SHOW_ERROR';
export const FILETYPE_SHOW_LOADING = 'FILETYPE_SHOW_LOADING';
export const FILETYPE_SHOW_RETRIEVED_SUCCESS = 'FILETYPE_SHOW_RETRIEVED_SUCCESS';
export const FILETYPE_SHOW_RESET = 'FILETYPE_SHOW_RESET';

// Update types
export const FILETYPE_UPDATE_RESET = 'FILETYPE_UPDATE_RESET';
export const FILETYPE_UPDATE_UPDATE_ERROR = 'FILETYPE_UPDATE_UPDATE_ERROR';
export const FILETYPE_UPDATE_UPDATE_LOADING = 'FILETYPE_UPDATE_UPDATE_LOADING';
export const FILETYPE_UPDATE_UPDATE_SUCCESS = 'FILETYPE_UPDATE_UPDATE_SUCCESS';
export const FILETYPE_UPDATE_RETRIEVE_ERROR = 'FILETYPE_UPDATE_RETRIEVE_ERROR';
export const FILETYPE_UPDATE_RETRIEVE_LOADING = 'FILETYPE_UPDATE_RETRIEVE_LOADING';
export const FILETYPE_UPDATE_RETRIEVE_SUCCESS = 'FILETYPE_UPDATE_RETRIEVE_SUCCESS';
export const FILETYPE_UPDATE_UPDATE_VIOLATIONS = 'FILETYPE_UPDATE_UPDATE_VIOLATIONS';

// List types
export const FILETYPE_LIST_ERROR = 'FILETYPE_LIST_ERROR';
export const FILETYPE_LIST_LOADING = 'FILETYPE_LIST_LOADING';
export const FILETYPE_LIST_RESET = 'FILETYPE_LIST_RESET';
export const FILETYPE_LIST_VIEW = 'FILETYPE_LIST_VIEW';
export const FILETYPE_LIST_SUCCESS = 'FILETYPE_LIST_SUCCESS';



// WEBPACK FOOTER //
// ./src/store/modules/filetype/mutation-types.js